const login = token => {
  localStorage.setItem('authorization', token)
}

const token = () => {
  return localStorage.getItem('authorization')
}

const logOff = () => {
  localStorage.removeItem('authorization')
}

export default { login, token, logOff }
